import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faTelegram, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import MonitorService from '../../../controllers/MonitorService';
import { selectionTypes } from '../../utils/consts';
import WidgetSettings from './widgetsettings';
import { faRainbow, faSms } from "@fortawesome/free-solid-svg-icons";
import Tooltip from 'react-bootstrap/Tooltip';

class OutgoingCallsSummary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showSettings: false,
            all: 0,
            attended: 0,
            missed: 0,
            groupId: -1,
            groupName: "",
            channel: "",
            channelName: ""
        };

        this.updateState = this.updateState.bind(this);
        this.setGroupAndChannel = this.setGroupAndChannel.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);
    }
    updateState(chatssummary) {
        var data = JSON.parse(chatssummary.body);

        this.setState({
            all: (data.attendedToday + data.missedToday),
            attended: data.attendedToday,
            missed: data.missedToday
        });

    }

    setGroupAndChannel(groupId, groupName, channel, channelName) {

        this.setState({
            showSettings: !this.state.showSettings,
            groupId: groupId,
            groupName: groupName,
            channel: channel,
            channelName: channelName
        });
        localStorage.setItem(`SocialSummary_groupId_${this.props.userId}`, groupId);
        localStorage.setItem(`SocialSummary_groupName_${this.props.userId}`, groupName);
        localStorage.setItem(`SocialSummary_channel_${this.props.userId}`, channel);
        localStorage.setItem(`SocialSummary_channelName_${this.props.userId}`, channelName);
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/chatssummary", {}, JSON.stringify({
                token: this.props.token,
                widgetId: this.props.userId,
                groupId: groupId,
                channel: channel,
                userId: this.props.userId
            }));
        }

    };
    getIcon(channel) {
        let elem = <FontAwesomeIcon icon={duotone("chart-network")} />;
        if (channel === "facebook")
            elem = <FontAwesomeIcon icon={faFacebook} />;
        if (channel === "whatsapp")
            elem = <FontAwesomeIcon icon={faWhatsapp} />;
        if (channel === "instagram")
            elem = <FontAwesomeIcon icon={faInstagram} />;
        if (channel === "twitter")
            elem = <FontAwesomeIcon icon={faTwitter} />;
        if (channel === "sms")
            elem = <FontAwesomeIcon icon={faSms} />;
        if (channel === "telegram")
            elem = <FontAwesomeIcon icon={faTelegram} />;
        if (channel === "rainbow")
            elem = <FontAwesomeIcon icon={faRainbow} />;
        return elem;
    }


    toggleSettings() {
        this.setState({
            showSettings: !this.state.showSettings
        });
    }

    componentDidMount() {

        let groupId = parseInt(localStorage.getItem(`SocialSummary_groupId_${this.props.userId}`) || -1);
        let groupName = localStorage.getItem(`SocialSummary_groupName_${this.props.userId}`) || this.props.t("all2");
        let channel = localStorage.getItem(`SocialSummary_channel_${this.props.userId}`) || "";
        this.setState({
            groupId: groupId,
            groupName: groupName,
            channel: channel
        });

        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.subscribe(`/user/${this.props.token}/topic/chatssummary_${this.props.userId}/`, this.updateState, { id: `chatssummary_${this.props.userId}` });

            MonitorService.stompClient.send("/app/subscribe/chatssummary", {}, JSON.stringify({
                token: this.props.token,
                widgetId: this.props.userId,
                groupId: groupId,
                userId: this.props.userId,
                channel: channel
            }));
        }


    }

    componentWillUnmount() {
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send(`/user/topic/chatssummary_${this.props.userId}/`, {}, JSON.stringify({ token: this.props.token }));
            MonitorService.stompClient.unsubscribe(`chatssummary_${this.props.userId}`);
        }
    }

    render() {
        return (<div className='position-relative'>
            <div className={"card card-flush overflow-hidden widget-container"} style={{ width: "100%", height: "100%", margin: "0px" }}>
                <div className="card-header drag-handle">
                    <h3 className="card-title align-items-start flex-column text-primary">
                        <span className="card-label fw-bold text-primary">{this.getIcon(this.state.channel)} {this.state.channelName ? this.state.channelName : this.props.t("socialnetworks")} - {this.state.groupName}</span>
                    </h3>
                    <div className="card-toolbar" style={{ zIndex: 1000 }}>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("config")}
                            </Tooltip>}>
                            <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={this.toggleSettings} >
                                <FontAwesomeIcon icon={duotone("grid-2")} />
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                    <Row>
                        <Col>
                            <div className="fs-3hx fw-bold text-gray-800 statsnumber">{(this.state.all)}</div>
                            <div className="fs-5 fw-semibold text-gray-400 mb-7">{this.props.t("total")}</div>
                        </Col>
                        <Col> <div className="fs-3hx fw-bold text-success statsnumber">{this.state.attended}</div>
                            <div className="fs-5 fw-semibold text-gray-400 mb-7">{this.props.t("attended")}</div>
                        </Col>
                        <Col> <div className="fs-3hx fw-bold text-danger statsnumber">{this.state.missed}</div>
                            <div className="fs-5 fw-semibold text-gray-400 mb-7">{this.props.t("missed")}</div>
                        </Col>
                    </Row>
                </div>

            </div>
            <WidgetSettings showSettings={this.state.showSettings} toggleSettings={this.toggleSettings} token={this.props.token} setGroupAndChannel={this.setGroupAndChannel} groupId={this.state.groupId} groupName={this.state.groupName} selectionType={selectionTypes.CHANNEL} channel={this.state.channel} channelName={this.state.channelName}></WidgetSettings>
        </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
    };
};

export default compose(connect(mapStateToProps, null), withTranslation())(OutgoingCallsSummary);